import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Salvador de Jujuy'];
const argentineNames = ['Martín González', 'Lucas Fernández', 'Diego Rodríguez', 'Pablo Martínez', 'Javier López', 'Sebastián García', 'Matías Pérez', 'Fernando Sánchez', 'Lucía Romero', 'Carolina Torres', 'Valeria Díaz', 'Florencia Ruiz', 'Gabriela Castro', 'Andrea Morales', 'Natalia Suárez'];
export function PurchaseNotification() {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = argentineNames[Math.floor(Math.random() * argentineNames.length)];
      const randomCity = argentineCities[Math.floor(Math.random() * argentineCities.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setShow(true);
      setTimeout(() => setShow(false), 5000);
    };
    const interval = setInterval(showNotification, 15000);
    setTimeout(showNotification, 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-375">
      {show && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: 50
    }} className="fixed bottom-6 right-6 z-50 bg-white rounded-lg shadow-2xl p-4 max-w-sm border-l-4 border-green-600" data-id="element-376">
          <button onClick={() => setShow(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-377">
            <div className="w-4 h-4" data-id="element-378" />
          </button>
          <div className="flex items-start gap-3" data-id="element-379">
            <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-380" />
            <div data-id="element-381">
              <p className="font-semibold text-gray-900 text-sm" data-id="element-382">
                ¡Compra confirmada!
              </p>
              <p className="text-xs text-gray-600 mt-1" data-id="element-383">
                <span className="font-medium" data-id="element-384">{notification.name}</span> de{' '}
                <span className="font-medium" data-id="element-385">{notification.city}</span> acaba
                de comprar Baby Fútbol Resuelto
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-386">Hace unos minutos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}